module.exports = __webpack_public_path__ + "img/47.274a21e1.svg";